import styled from 'styled-components';
import { mediaQueries } from 'utils/Constants/Breakpoints';
import { Section } from 'View/Container';
import { asRem } from 'utils/asRem';

export const StyledSection = styled(Section)`
  margin: 0 0;
  padding-bottom: 0;
  position: relative;

  .text-wrapper {
    text-align: center;

    ${mediaQueries.md} {
      text-align: left;
    }
  }

  .luna-wrapper {
    display: flex;
    justify-content: center;
    ${mediaQueries.md} {
      justify-content: flex-start;
      margin-bottom: unset;
    }
  }

  .luna-image {
    margin-top: ${asRem(-10)};
    margin-bottom: ${asRem(20)};

    ${mediaQueries.md} {
      margin-top: ${asRem(-60)};
    }
  }

  .image-wrapper {
    ${mediaQueries.md} {
      justify-content: flex-end;
      display: flex;
    }
  }
`;
